module.exports = __webpack_public_path__ + "static/award2-31076762a3f127192c210d8d8c37f61a.png";